import { CheckableFieldContext } from "./chunk-EYE6MH2Q.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableField/CheckableField.Image.tsx
import { useContext } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var CheckableFieldImage = _a => {
  var _b = _a,
    {
      className,
      children
    } = _b,
    rest = __objRest(_b, ["className", "children"]);
  const {
    id
  } = useContext(CheckableFieldContext);
  if (!children) {
    return null;
  }
  return /* @__PURE__ */jsx("figure", __spreadProps(__spreadValues({}, rest), {
    id: "".concat(id, "-image"),
    className: clsx("pd:checkable-field__image", className),
    children
  }));
};
var CheckableField_Image_default = CheckableFieldImage;
export { CheckableField_Image_default };